const borderStyle = {
  name: "border-style",
  path: "/border-style",
  title: "border-style",
  description: "Utilities for controlling the style of an element's borders.",
  value: {
    'border-style': {
      'border-style-solid': 'solid;',
      'border-style-dashed': 'dashed;',
      'border-style-dotted': 'dotted;',
      'border-style-double': 'double;',
      'border-style-hidden': 'hidden;',
      'border-style-none': 'none;',
    },
    '': {
      "divide-style-solid":
        `& > :not(:last-child) {
  border-style: solid;
}`,
      "divide-style-dashed":
        `& > :not(:last-child) {
  border-style: dashed;
}`,
      "divide-style-dotted":
        `& > :not(:last-child) {
  border-style: dotted;
}`,
      "divide-style-double":
        `& > :not(:last-child) {
  border-style: double;
}`,
      "divide-style-hidden":
        `& > :not(:last-child) {
  border-style: hidden;
}`,
      "divide-style-none":
        `& > :not(:last-child) {
  border-style: none;
}`,
    },
  },
  exampleData: [
    {
      example: {
        code: `<div class="border-style-solid border-2 border-color-blue-500 p-4">border-style-solid</div>
<div class="border-style-dashed border-2 border-color-blue-500 p-4">border-style-dashed</div>
<div class="border-style-dotted border-2 border-color-blue-500 p-4">border-style-dotted</div>
<div class="border-style-double border-4 border-color-blue-500 p-4">border-style-double</div>
`
      }
    },
    {
      example: {
        code: `<div class="grid grid-columns-3 divide-x-2 divide-style-solid divide-color-blue-500">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>

<div class="flex flex-col divide-y-2 divide-style-dashed divide-color-blue-500">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">border-style-solid</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">border-style-dashed</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">border-style-dotted</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">border-style-double</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">border-style-hidden</code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">border-style-none</code> to set the border style of an element.
      </p>
      <div class="flex justify-center gap-6 items-center font-mono text-sm font-bold flex-wrap">
        <div class="border-style-solid border-2 border-color-blue-500 p-4 flex justify-center gap-6 items-center">border-style-solid</div>
        <div class="border-style-dashed border-2 border-color-blue-500 p-4 flex justify-center gap-6 items-center">border-style-dashed</div>
        <div class="border-style-dotted border-2 border-color-blue-500 p-4 flex justify-center gap-6 items-center">border-style-dotted</div>
        <div class="border-style-double border-4 border-color-blue-500 p-4 flex justify-center gap-6 items-center">border-style-double</div>
      </div>
      `
    },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">divide-style-solid</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">divide-style-dashed</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">divide-style-dotted</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">divide-style-double</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">divide-style-hidden</code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">divide-style-none</code> to set the border style between child elements.
      </p>
      <div class="grid border border-color-gray-200 grid-columns-3 divide-x-2 divide-style-solid divide-color-blue-500 *:flex *:justify-center *:items-center *:p-4">
        <div>01</div>
        <div>02</div>
        <div>03</div>
      </div>
      <div class="flex border border-color-gray-200 flex-col mt-10 divide-y-2 divide-style-dashed divide-color-blue-500 *:flex *:justify-center *:items-center *:p-4">
        <div>01</div>
        <div>02</div>
        <div>03</div>
      </div>
      `
    }
  ]
};

export default borderStyle;

<div class="sr-only flex justify-center gap-6 items-center font-mono text-sm font-bold flex-wrap">
<div class="border-style-solid border-2 divide-x-2 divide-y-2 divide-style-solid divide-style-dashed border-color-blue-500 p-4 h-20">border-style-solid</div>
        <div class="border-style-dashed border-2 border-color-blue-500 p-4 h-20">border-style-dashed</div>
        <div class="border-style-dotted border-2 border-color-blue-500 p-4 h-20">border-style-dotted</div>
        <div class="border-style-double border-2 border-color-blue-500 p-4 h-20">border-style-double</div>
        <div class="border-style-hidden border-2 border-color-blue-500 p-4 h-20">border-style-hidden</div>
        <div class="border-style-none border-2 border-color-blue-500 p-4 h-20">border-style-none</div>
</div>